import { spacing } from '../../style';

const borderRadiusOptions = {
  xs: {
    size: spacing.tiny,
  },
  sm: {
    size: spacing.xxs,
  },
  md: {
    size: spacing.xs,
  },
  lg: {
    size: spacing.sm,
  },
  xl: {
    size: spacing.md,
  },
  round: {
    size: '50%',
  },
  pill: {
    size: '9999px',
  },
  none: {
    size: 0,
  },
};

export { borderRadiusOptions };
